module.exports = function (context) {
  if (_.isString(context)) {
    return $('<p>' + context + '</p>')
      .text()
      .trim();
  } else {
    return context;
  }
};
